<template lang="pug">
    include ../../media/pug/mixins
    +b.markers-list-item
        +e.BUTTON.remove.btn._icon(
            type="button"
        )
            v-icon(name="close").icon_small
        +e.inner(
            v-on:click="changePage(item)"
        )
            +e.content
                +e.picture(
                    v-lazyload="true"
                    v-bind:data-counter="3"
                    v-bind:class="{'is-active' : $route.query.page == item}"
                )
                    +e.IMG.img(
                        v-bind:data-url="`${apiUrl}/viewer/pdf?docId=${$route.params.id}&page=${item}&type=preview`"
                        alt=''
                    )
                +e.P.desc {{ $t('PAGE_N', {number: item}) }}
            +e.BUTTON.toggle.btn._round._theme_fill(
                type="button"
                v-on:click="toggleContent"
                v-bind:class="{'is-active' : contentIsOpened}"
            )
        collapse-transition
            +e.dropdown(v-if="contentIsOpened")
                +e.UL.list
                    +e.LI.list-item._active
                        +e.V-ICON.list-icon(name="mark")
                        +e.P.list-desc Автор и название
                        +e.BUTTON.list-remove.btn._icon
                            v-icon(name="trash")
                    +e.LI.list-item
                        +e.V-ICON.list-icon(name="shape")
                        +e.P.list-desc Область 1
                        +e.BUTTON.list-remove.btn._icon
                            v-icon(name="trash")
                    +e.LI.list-item
                        +e.V-ICON.list-icon(name="text")
                        +e.P.list-desc Автор и название
                        +e.BUTTON.list-remove.btn._icon
                            v-icon(name="trash")

</template>

<script>
import { mapGetters } from 'vuex';
import { CollapseTransition } from 'vue2-transitions';
import setApiUrl from '@/helpers/api';

export default {
    components: {
        CollapseTransition
    },
    props: {
        item: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            apiUrl: setApiUrl(),
            contentIsOpened: false
        };
    },
    computed: {
        ...mapGetters([
            'isMobile',
            'getIsOnePage',
            'getGeneralInfo'
        ])
    },
    methods: {
        toggleContent() {
            this.contentIsOpened = !this.contentIsOpened;
        },
        changePage(page) {
            const { rotate, negative } = this.$route.query;
            this.$router.push({
                query: {
                    page,
                    rotate,
                    negative
                }
            });
        }
    }

};
</script>
